import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { appDocumentTitle } from '../appMeta';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function NotFoundPage() {
  useDocumentTitle(appDocumentTitle('Page not found'));

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Button component={RouterLink} to="/dashboard" variant="contained" data-testid="not-found-home">
        Back to dashboard
      </Button>
    </Box>
  );
}
